export const getFormattedH1Title = (h1Title: string): string => {
  const lowerCasedH1Title = h1Title.toLocaleLowerCase().trim()

  return `${lowerCasedH1Title[0].toUpperCase()}${lowerCasedH1Title.slice(1)}`
}
